<template>
  <div>
    포트폴리오 리스트 디폴트 레이아웃
  </div>
</template>

<script>
export default {
  name: "PortfolioListDefaultLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      idx: 1
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    goDetail(idx) {
      this.$router.push(`/member/${idx}`);
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>